<template>
  <div class="content-wrapper">
    <div class="grid-options" :class="{
      'start-option':
        question.config.options[0].title == 'Uhr' ||
        question.config.options[0].title == 'Schmuck',

      'grid-repeat-2': optionList.length >= 2,

      'grid-repeat-4': optionList.length >= 4 && question.label == 'Marke',

      'grid-repeat-6': optionList.length >= 6 && question.label == 'Marke' && question.diagnosis.answers[1][0].answer !== 'schmuck',

      jewelry:
        question.diagnosis.answers &&
        question.diagnosis.answers[1][0].answer == 'schmuck',

      questioning:
        question.label != 'Marke' &&
        question.config.options[0].title != 'Uhr' &&
        question.config.options[0].title != 'Schmuck',

      'more-than-2': optionList.length > 2,
    }">
      <div v-for="option in optionList" :key="option.value">
        <div v-if="question.config.options[0].title === 'Uhr' ||
          question.config.options[0].title === 'Schmuck'
          ">
          <div :id="'wrapper' + option.value" class="option-wrapper">
            <label class="start-option-label">
              <input :id="option.value" v-model="answers" class="start-option-input d-none" type="radio"
                :value="option.value" :disabled="Array.isArray(answers) &&
                  question.config.max <= answers.length &&
                  !answers.includes(option.value)
                  " @click="changeDiv(option.value)" />
              <div v-if="option.image" class="start-option-img">
                <img :src="option.image.preview ? option.image.preview : option.image
                  " :alt="option.title" class="card-img-center img-fluid" />
              </div>
              <div v-else class="start-option-img">
                <p>{{ option.value }}</p>
              </div>
              <span class="start-option-title">{{ option.title }}
                <b-button v-if="option.info" variant="link" :id="'popover' + option.value" class="popover-btn">
                  <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
                </b-button>
                <b-popover v-if="option.info" :target="'popover' + option.value" :content="option.info"
                  triggers="hover focus" placement="topright"
                  style="background-color: #1a1a1a; color: #ffffff"></b-popover>
              </span>
              <img src="@/assets/images/diagnosis/green_tick.svg" :id="'tick' + option.value" class="selected-tick" />
            </label>
          </div>
        </div>
        <div v-else-if="question.label === 'Marke'">
          <div :id="'brand' + option.value" class="brand-wrapper">
            <label class="brand-option-label">
              <input :id="option.value" v-model="answers" class="brand-option-input d-none" type="radio"
                :value="option.value" :disabled="Array.isArray(answers) &&
                  question.config.max <= answers.length &&
                  !answers.includes(option.value)
                  " @click="changeDiv(option.value)" />
              <div v-if="option.image" class="brand-option-img">
                <img :src="option.image.preview ? option.image.preview : option.image" :alt="option.title"
                  class="card-img-center img-fluid" />
              </div>
              <div v-else class="brand-option-img">
                <p style="margin-top: 6px !important">{{ option.title }}</p>
                <b-button v-if="option.info" variant="link" :id="'popover' + option.value" class="popover-btn">
                  <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
                </b-button>
                <b-popover v-if="option.info" :target="'popover' + option.value" :content="option.info"
                  triggers="hover focus" placement="topright"
                  style="background-color: #1a1a1a; color: #ffffff"></b-popover>
              </div>
              <img src="@/assets/images/diagnosis/green_tick.svg" :id="'tick' + option.value" class="selected-tick" />
            </label>
          </div>
        </div>
        <div v-else>
          <div v-if="question.config.max > 1">
            <b-form-checkbox :id="'check' + option.value" v-model="answers" :value="option.value" class="custom-checkbox">
              {{ option.title }}
              <b-button v-if="option.info" variant="link" :id="'popover' + option.value" class="popover-btn">
                <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
              </b-button>
              <b-popover v-if="option.info" :target="'popover' + option.value" :content="option.info"
                triggers="hover focus" placement="topright" style="background-color: #1a1a1a; color: #ffffff"></b-popover>
            </b-form-checkbox>
          </div>
          <div v-if="question.config.max === 1">
            <b-form-radio :id="'radio' + option.value" v-model="preSelect" :value="option.value" class="custom-radio"
              @change="updateRadio()">
              <p class="option-title">{{ option.title }}</p>
              <b-button v-if="option.info" variant="link" :id="'popover' + option.value" class="popover-btn">
                <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
              </b-button>
              <b-popover v-if="option.info" :target="'popover' + option.value" :content="option.info"
                triggers="hover focus" placement="topright" style="background-color: #1a1a1a; color: #ffffff"></b-popover>
            </b-form-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridOptionList",
  props: {
    optionList: Array,
  },
  data() {
    return {
      openedModal: null,
      preSelect: "",
    };
  },
  mounted() {
    if (this.question.label != 'Marke' && this.question.config.options[0].title != 'Uhr' &&
      this.question.config.options[0].title != 'Schmuck') {
      if (
        this.question.config.max === 1 &&
        this.question.selectedAnswers.length === 0
      ) {
        this.updateRadio();
      } else {
        this.preSelect = this.question.selectedAnswers;
      }
    }
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false;
    },
    answers: {
      get() {
        return this.question.selectedAnswers ?? "";
      },
      set(value) {
        this.$store.commit("updateSelectedAnswers", value);
      },
    },
  },
  methods: {
    showModal(id, ev) {
      ev.preventDefault();
      this.openedModal = id;
    },
    activeOption(value) {
      if (this.question.config.max == 1 && value == this.answers) {
        return true;
      }
      if (this.question.config.max > 1 && this.answers.includes(value)) {
        return true;
      }
      return false;
    },
    checkIfAlreadyAnswered(value) {
      if (this.question.config.max == 1 && value == this.answers) {
        this.$parent.$parent.nextQuestion();
      }
    },
    changeDiv(id) {
      let list = document.querySelectorAll('[id^="wrapper"]');
      let list2 = document.querySelectorAll('[id^="tick"]');
      let list3 = document.querySelectorAll('[id^="brand"]');
      list.forEach((inp) => {
        inp.style.borderColor = "transparent";
      });
      list2.forEach((inp) => {
        inp.style.display = "none";
      });
      list3.forEach((inp) => {
        inp.style.border = "thin solid #F0F0F0";
      });
      if (list.length !== 0) {
        document.getElementById("wrapper" + id).style.borderColor = "#2DA64F";
      }
      if (list2.length !== 0) {
        document.getElementById("tick" + id).style.display = "unset";
      }
      if (list3.length !== 0) {
        document.getElementById("brand" + id).style.borderColor = "#2DA64F";
      }
    },
    updateRadio() {
      if (
        this.question.selectedAnswers.length === 0 &&
        this.optionList.length !== 0
      ) {
        this.preSelect = this.optionList[0].value;
      }
      if (this.preSelect) {
        this.$store.commit("updateSelectedAnswers", this.preSelect);
      }
    },
  },
};
</script>
